/* eslint-disable max-len */
import React from "react";
import "../../../styles/ApplicationTable.css";

const statusColors = {
  Active: "#9FE6D1",
  Closed: "#F7C6D0",
  Inreview: "#BEE3F8",
};
const activeText = {
  Active: "#9FE6D1",
  Closed: "#F7C6D0",
  Inreview: "#BEE3F8",
};

const ApplicationTable = ({ data }) => (
  <div className="app-table-container">
    <table className="app-table">
      <thead>
        <tr>
          <th>Case ID</th>
          <th>Application Status</th>
          <th>Last Updated</th>
          <th>Updated By</th>
          <th>Assigned To</th>
          <th>Notes</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr>
            <td>{row.caseId}</td>
            <td>
              {' '}
              <span
                className="status-pill-appTable"
                // style={{ backgroundColor: statusColors[row.appStatus], color: activeText[row.appStatus] }}
              >
                {row.appStatus}
              </span>
            </td>
            <td>{row.lastUpdate}</td>
            <td>{row.updateBy}</td>
            <td>{row.assignedTo}</td>
            <td>{row.Notes}</td>
            <td>...</td>
            {/* Status Pill */}
            {/* <td>
              <span
                className="status-pill"
                style={{ backgroundColor: statusColors[row.status] }}
              >
                {row.status}
              </span>
            </td> */}

          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
export default ApplicationTable;
